import { API_ENDPOINTS } from "../constants/apiEndpoints";
import axiosInstance from "../config/axiosInstance";

/**
 * Lấy danh sách consulting theo ngôn ngữ và navMenuId
 * @param {string} languageCode - Mã ngôn ngữ (vd: 'vi', 'en')
 * @param {number} navMenuId    - ID của nav menu con
 * @returns {Promise<Array>}
 */
export const getConsultingsByNavMenuId = async (languageCode, navMenuId) => {
    try {
        const response = await axiosInstance.get(
            API_ENDPOINTS.CONSULTINGS.GET_BY_NAV_MENU_ID(languageCode, navMenuId)
        );
        const data = response.data;

        if (data && data.success && Array.isArray(data.data)) {
            return data.data;
        }
        if (Array.isArray(data)) {
            return data;
        }
        if (data && Array.isArray(data.data)) {
            return data.data;
        }
        return [];
    } catch (error) {
        console.error("Lỗi khi lấy danh sách consulting:", error);
        throw error;
    }
};

export const getConsultingsByLanguage = async (languageCode) => {
    try {
        const response = await axiosInstance.get(
            API_ENDPOINTS.CONSULTINGS.GET_BY_LANGUAGE(languageCode)
        );
        const data = response.data;

        if (data && data.success && Array.isArray(data.data)) return data.data;
        if (Array.isArray(data)) return data;
        if (data && Array.isArray(data.data)) return data.data;
        return [];
    } catch (error) {
        console.error("Lỗi khi lấy toàn bộ danh sách consulting:", error);
        throw error;
    }
};
